export default {
  messages: {
    date_not_future:
      "The selected date is in the past. Please choose a future date",
  },
};
